const initialState = {
  apiPrefix: '/agent_portal/api',
  webpageBase: '/a/portal',
  trackCommentViews: true,
};

export default function configurationReduce(state = initialState, action) {
  return state;
}
